
      function openTab(evt, tabId) {
        const container = evt.target.closest(".product_size_tab");

        container
          .querySelectorAll(".tab_btn")
          .forEach((btn) => btn.classList.remove("active"));

        container
          .querySelectorAll(".content")
          .forEach((content) => content.classList.remove("active"));

        evt.target.classList.add("active");
        container.querySelector("#" + tabId).classList.add("active");
      }